import {
  ENTITLEMENT_ERROR_CODES,
  type EntitlementErrorBody,
} from './entitlementError';

/**
 * Type guard for "this response body is an entitlement-gating refusal from
 * the server (SP3) rather than a generic 4xx." Lives in shared/ so web,
 * extension, and Android clients can detect it identically.
 */
export function isEntitlementErrorResponse(
  body: unknown,
): body is EntitlementErrorBody {
  if (typeof body !== 'object' || body === null || Array.isArray(body)) {
    return false;
  }
  const maybeCode = (body as { code?: unknown }).code;
  if (typeof maybeCode !== 'string') return false;
  return (ENTITLEMENT_ERROR_CODES as readonly string[]).includes(maybeCode);
}
